'use client'

import { AbhaHeroSuccessBadge } from '@components/NewProduct/AbhaHeroWidget/steps/AbhaHeroSuccessBadge'
import type { AbhaSuccessPanelHeader } from '@components/NewProduct/AbhaHeroWidget/steps/abhaSuccessRightPanelTypes'
import PropertyControlledComponent from '@components/PropertyControlledComponent/PropertyControlledComponent'
import { getClassNames } from '@helpers/productWidgetHelper'

export type AbhaHeroSuccessPanelHeaderProps = {
  header: AbhaSuccessPanelHeader
  isMobile?: boolean
  badgeVariant?: 'default' | 'onDark' | 'onLight' | 'onShowSurface'
  align?: 'left' | 'center'
  badgeOnly?: boolean
}

export const AbhaHeroSuccessPanelHeader = ({
  header,
  isMobile = false,
  badgeVariant = 'default',
  align = 'left',
  badgeOnly = false,
}: AbhaHeroSuccessPanelHeaderProps) => (
  <header
    className={getClassNames(
      [
        'abha-hero-success-panel__header',
        isMobile ? 'abha-hero-success-panel__header--mobile' : 'abha-hero-success-panel__header--desktop',
      ],
      {
        'abha-hero-success-panel__header--center': align === 'center',
        'abha-hero-success-panel__header--badge-only': badgeOnly,
      }
    )}>
    <PropertyControlledComponent controllerProperty={!!header?.badgeText} fallback={null}>
      <AbhaHeroSuccessBadge label={header?.badgeText || ''} variant={badgeVariant} />
    </PropertyControlledComponent>

    <PropertyControlledComponent controllerProperty={!badgeOnly && !!header?.title} fallback={null}>
      <h2 className="abha-hero-success-panel__title">{header?.title}</h2>
    </PropertyControlledComponent>

    <PropertyControlledComponent controllerProperty={!badgeOnly && !!header?.description} fallback={null}>
      <p className="abha-hero-success-panel__description">{header?.description}</p>
    </PropertyControlledComponent>
  </header>
)
